import { lazy, Suspense } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';

const ServicesSection = lazy(() => import('@/components/ServicesSection'));
const BookingSection = lazy(() => import('@/components/BookingSection'));
const Testimonials = lazy(() => import('@/components/Testimonials'));
const AboutSection = lazy(() => import('@/components/AboutSection'));
const InstagramFeed = lazy(() => import('@/components/InstagramFeed'));
const ContactSection = lazy(() => import('@/components/ContactSection'));
const SiteFooter = lazy(() => import('@/components/SiteFooter'));
const FloatingButtons = lazy(() => import('@/components/FloatingButtons'));
const CookieConsent = lazy(() => import('@/components/CookieConsent'));

const Index = () => {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <ServicesSection />
          <BookingSection />
          <Testimonials />
          <AboutSection />
          <InstagramFeed />
          <ContactSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <SiteFooter />
        <FloatingButtons />
        <CookieConsent />
      </Suspense>
    </>
  );
};

export default Index;
